export const trustPilotConfig = {
  "review-data-template-id": "539adbd6dec7e10e686debee",
  "rating-data-template-id": "5419b6ffb0d04a076446a9af",
  "new-data-template-id": "5419b637fa0340045cd0c936",
  "data-businessunit-id": {
    "en-GB": "5a9cf197e2784500013cef6d",
    "en-US": "5be30df26feb63000166cc02",
  },
  url: {
    "en-GB": "https://uk.trustpilot.com/review/www.beautypie.com",
    "en-US": "https://www.trustpilot.com/review/www.beautypie.com/us",
  },
}
